import React from 'react';
import { compareValues } from "../helpers";


const VenuesFilters = ({ filters, setFilterOption }) =>
    (
        <React.Fragment>
            {
                Object.keys(filters).map((filter) =>
                    <div key={filter} className="mb-4">
                        <hr className="meta-separator mr-auto"/>
                        <h3 className="w-100 text-primary font-weight-extrabold text-capitalize"
                        >{filter}</h3>

                        { Object.values(filters[filter]).sort(compareValues('weight')).map((option, index) => {
                            return (
                                <div
                                    key={option.value}
                                    className="js-form-item js-form-type-checkbox checkbox form-check filter-row mb-1">
                                    <input type="checkbox"
                                           className="form-checkbox form-check-input"
                                           id={`${filter}-${index}`}
                                           checked={option.active}
                                           onChange={(e)=>{setFilterOption(filter, option, e.target.checked)}}
                                    />
                                    <label
                                        htmlFor={`${filter}-${index}`}
                                        className="js-form-item js-form-type-checkbox checkbox form-check form-check-label text-uppercase p-0 text-dark"
                                    >
                                        {option.value}
                                    </label>
                                </div>
                            )
                        })}
                    </div>
                )
            }
        </React.Fragment>
    )

export default VenuesFilters;